import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50 rounded-t-2xl">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8 max-w-7xl mx-auto">
          <div>
            <p className="text-3xl md:text-4xl font-heading font-light text-background-50 mb-4">
              Stay Updated
            </p>
            <p className="text-sm text-background-500 leading-relaxed mb-8 max-w-xs">
              Get the latest AllChinaBuy spreadsheet updates, new seller alerts, and buying tips delivered to your inbox.
            </p>
            <form
              className="flex flex-col sm:flex-row gap-3"
              data-readdy-form="newsletter"
              action="https://readdy.ai/api/form/d8ujamtu37m8lq7g362g"
              method="POST"
            >
              <input
                type="text"
                name="website_alt"
                className="honeypot-field"
                tabIndex={-1}
                autoComplete="off"
                aria-hidden="true"
              />
              <input
                type="email"
                name="email"
                placeholder="Your email address"
                required
                className="flex-1 bg-transparent border-b border-background-700 text-sm text-background-50 placeholder-background-500 py-2 px-0 focus:outline-none focus:border-primary-400 transition-colors"
              />
              <button
                type="submit"
                className="px-5 py-2 bg-background-50 text-foreground-950 text-sm font-medium rounded-full hover:bg-background-100 transition-colors whitespace-nowrap cursor-pointer inline-flex items-center gap-1.5"
              >
                Subscribe
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </button>
            </form>
          </div>

          <div>
            <p className="text-xs font-label font-semibold text-background-400 uppercase tracking-wider mb-5">
              Quick Links
            </p>
            <div className="flex flex-col gap-3">
              <Link to="/" className="text-sm text-background-300 hover:text-background-50 transition-colors underline underline-offset-4">
                Home
              </Link>
              <Link to="/allchinabuy-spreadsheet-guide" className="text-sm text-background-300 hover:text-background-50 transition-colors underline underline-offset-4">
                Complete Buying Guide
              </Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-background-300 hover:text-background-50 transition-colors underline underline-offset-4">
                Shop Now
              </a>
              <a href="#categories" className="text-sm text-background-300 hover:text-background-50 transition-colors underline underline-offset-4">
                Categories
              </a>
            </div>
          </div>

          <div>
            <p className="text-xs font-label font-semibold text-background-400 uppercase tracking-wider mb-5">
              Contact & Info
            </p>
            <p className="text-sm text-background-300 mb-1">
              hello@allchinabuyspreadsheet.bar
            </p>
            <div className="mt-8">
              <p className="text-xs font-label font-semibold text-background-400 uppercase tracking-wider mb-2">
                Our Mission
              </p>
              <p className="text-sm text-background-400 leading-relaxed">
                Helping buyers discover quality products through curated spreadsheets and trusted seller recommendations.
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="w-full px-4 md:px-6 py-5 max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-3">
            <div className="flex items-center gap-5">
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-400 hover:text-background-200 transition-colors underline underline-offset-4">
                Main Site
              </a>
              <Link to="/" className="text-xs text-background-400 hover:text-background-200 transition-colors underline underline-offset-4">
                Privacy Policy
              </Link>
            </div>
            <p className="text-xs text-background-500">
              &copy; {new Date().getFullYear()} AllChinaBuySpreadsheet. All rights reserved.
            </p>
            <div className="flex items-center gap-5">
              <Link to="/allchinabuy-spreadsheet-guide" className="text-xs text-background-400 hover:text-background-200 transition-colors underline underline-offset-4">
                Buying Guide
              </Link>
              <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-background-400 hover:text-background-200 transition-colors underline underline-offset-4">
                Terms
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}